export const base64ToBlob = (base64Data: string, contentType = 'image/jpeg'): Blob => {
    const byteString = typeof window !== 'undefined' && typeof window.atob === 'function'
        ? window.atob(base64Data.split(',')[1])
        : Buffer.from(base64Data.split(',')[1], 'base64').toString('binary')

    const byteNumbers = Array.from(byteString, char => char.charCodeAt(0))
    const byteArray = new Uint8Array(byteNumbers)
    return new Blob([byteArray], { type: contentType })
}

export const fetchImageAsBlobURL = async (imageUrl: string): Promise<string> => {
    try {
        const response = await fetch(imageUrl, {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache'
        })

        if (!response.ok) {
            const errorText = await response.text()
            console.error('Fetch Error:', response.status, errorText)
            throw new Error(`HTTP Error ${response.status}: ${errorText}`)
        }

        const blob = await response.blob()
        return URL.createObjectURL(blob)
    } catch (error) {
        console.error('Error fetching image:', error)
        return imageUrl
    }
}
